import { graphql } from 'gatsby';
import Image from '@components/Image/Image';
import * as React from 'react';
export default {
  graphql,
  Image,
  React
};